/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

'use client';
import React from 'react';
import { Pressable, Text, View } from 'react-native';
import { getTextStyle, pd } from '@airasia-phoenix/react-native/utils/utils';
import type { FeedbackButtonProps } from './types';
import styles from './styles';

const FeedbackButton: React.FC<FeedbackButtonProps> = ({
  label,
  onPress,
  style,
  textStyle,
}) => {
  return (
    <Pressable
      accessibilityRole="button"
      accessibilityLabel={label}
      onPress={onPress}
      style={({ pressed }) => [
        styles.button,
        pressed && styles.buttonPressed,
        style,
      ]}
    >
      <View style={styles.labelContainer}>
        <Text
          numberOfLines={1}
          style={[
            getTextStyle(
              pd.sys.typescale.sub_body_text_medium,
              pd.sys.colour.content_reversed,
            ),
            styles.label,
            textStyle,
          ]}
        >
          {label}
        </Text>
      </View>
    </Pressable>
  );
};

export default FeedbackButton;
